module.exports = __webpack_public_path__ + "media/images/athletes/252-0252dfc22bfa19eea459544d16a4f2b5.png";